import classNames from 'classnames'
import React from 'react'
import { isNullOrWhiteSpace } from '../../utilities/string'
import { TableListItem } from './TableListItem'

export interface TableListColumnDefinition {
  fontWeight?: string
  gapX?: string
  width?: string
  alignment?: string
}

export interface TableListColumnProps {
  isExternalLink?: boolean
  link?: string
  text: string
}

export interface TableListRow {
  columns?: TableListColumnProps[]
}

export interface TableListProps {
  additionalClassName?: string
  columnDefinitions?: TableListColumnDefinition[]
  listItemTextSize?: string
  linkTextColor?: string
  rowGapY?: string
  rows: TableListRow[]
  title?: string
  titleStyle?: 'normal' | 'tiny'
  topBorder?: boolean
}

export const TableList = ({
  additionalClassName = '',
  columnDefinitions = [],
  listItemTextSize,
  linkTextColor,
  rowGapY,
  rows,
  title,
  titleStyle = 'normal',
  topBorder = true,
}: TableListProps): JSX.Element => (
  <div className={classNames('text-secondary-darker', additionalClassName)}>
    {!isNullOrWhiteSpace(title) && (
      <h3
        className={classNames(
          'h-30 font-t',
          titleStyle === 'tiny'
            ? 'text-secondary-dark text-t-300 xl:text-t-500'
            : 'text-t-400 lg:text-t-500'
        )}
      >
        {title}
      </h3>
    )}

    <ul className={classNames({ 'border-t': topBorder }, listItemTextSize)}>
      {rows.map((row, rowIndex) => (
        <li
          className={classNames('flex border-b border-neutral-lighter', rowGapY)}
          key={rowIndex}
        >
          {row.columns?.map((column, colIndex) => (
            <TableListItem
              {...column}
              columnDefinition={columnDefinitions[colIndex]}
              key={colIndex}
              linkTextColor={linkTextColor}
            />
          ))}
        </li>
      ))}
    </ul>
  </div>
)
